<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Motorrijbewijs halen</h1>
      <p>
        Wil je graag zo snel mogelijk je motorrijbewijs gaan halen, maar weet je
        nog niet bij welke rijschool? Dan zit je goed op
        Rijscholenvergelijker.nl! Hier heeft iedereen de mogelijkheid om
        offertes te vergelijken van meerdere rijscholen in de regio. Ben je op
        zoek naar de beste
        <nuxt-link to="/informatie-over-rijscholen/rotterdam">
          rijschool in Rotterdam
        </nuxt-link>
        voor het halen van je motorrijbewijs? Wil je weten welke
        <nuxt-link to="/informatie-over-rijscholen/utrecht">
          rijschool rond Utrecht
        </nuxt-link>
        het laagste uurtarief hanteert? Welke
        <nuxt-link to="/informatie-over-rijscholen/den-haag">
          rijschool in Den Haag
        </nuxt-link>
        heeft het hoogste slagingspercentage? Via deze website kom je in contact
        met verschillende rijscholen en kun je in alle rust de offertes
        vergelijken, zodat je niet kiest voor de eerste rijschool voor het
        behalen van je motorrijbewijs.
      </p>

      <h2>Het motorrijbewijs</h2>
      <p>
        Wie het motorrijbewijs, ook wel rijbewijs A genoemd, in de wacht wil
        slepen en het rijbewijs B al op zak heeft, hoeft geen theoriecertificaat
        meer te behalen. In dat geval kun je dus meteen beginnen met de
        praktijklessen. Het examen voor het motorrijbewijs bestaat uit twee
        onderdelen: enerzijds het beheersen van het voertuig en anderzijds het
        deelnemen aan het verkeer. Daarnaast moet je er rekening mee houden dat
        er speciale eisen gelden op het gebied van kleding om jezelf te
        beschermen. Verder kun je als je jonger dan 21 bent alleen examen doen
        op een lichte motorfiets en is je motorrijbewijs twee jaar geldig voor
        deze motorfiets. Na die periode is het toegestaan om op een zware
        motorfiets te rijden.
      </p>

      <h2>Vergelijk gratis offertes!</h2>
      <p>
        Je doet er altijd verstandig aan om weloverwogen een keuze te maken voor
        een motorrijschool bij jou in de buurt. Zo word je niet alleen op
        veilige wijze voorbereid op de tijd nadat je je motorrijbewijs hebt
        behaald, maar kun je ook nog eens honderden euro’s besparen op je
        motorrijlessen. Vraag de offertes van verschillende
        <nuxt-link to="/"> rijscholen </nuxt-link> gratis, vrijblijvend en
        eenvoudig aan op Rijscholenvergelijker.nl, vergelijk de informatie
        zorgvuldig en kies voor de beste optie om je motorrijbewijs te behalen!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle:
        'Motorrijbewijs halen? Vergelijk gratis en vrijblijvend offertes!',
      headDescription:
        'Wil je je motorrijbewijs gaan halen,  dan kun je op Rijscholenvergelijker.nl terecht voor gratis offertes. Eerst vergelijken, dan motorrijles!Wil je je motorrijbewijs gaan halen,  dan kun je op Rijscholenvergelijker.nl terecht voor gratis offertes. Eerst vergelijken, dan motorrijles!',
    }
  },
}
</script>
